// extracted by mini-css-extract-plugin
export default {"address":"EntityAddress_address__tEkzE"};